import classNames from "classnames";
import React, { MouseEventHandler } from "react";
import h_decor_2 from "../../images/decors/h_decor_2.png";
import Styles from "./GameAssetsTabsBar.module.scss";

type GameAssetsTabsBarPropsType = {
	options: string[]
	activeOption: string
	onClick?: (item: string) => void
}

export const GameAssetsTabsBar = ({ options, activeOption, onClick }: GameAssetsTabsBarPropsType) => {
	const buildHandler: (item: string) => MouseEventHandler = (item: string) => () => {
		if (onClick) {
			onClick(item);
		}
	};

	return (
		<div className={Styles.styleGameAssetsTabBarContainer}>
			{options.map((item, index) => (
				<div
					className={classNames(Styles.styleGameAssetsTabBarItem, item === activeOption ? Styles.styleGameAssetsTabBarItemActive : Styles.styleGameAssetsTabBarItemInactive)}
					onClick={buildHandler(item)}
					key={item}
				>
					{item}
					{(index !== options.length - 1) && <img className={Styles.styleGameAssetsTabBarDivider} src={h_decor_2}/>}
				</div>
			))}
		</div>
	)
}
